import { FETCH_BIRTH_RELATORY_INIT } from './BirthRelatoryActions'

const INITIAL_STATE = {
  items: [],
  totalSize: 0,
  page: 1,
  sizePerPage: 10,
  filters: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BIRTH_RELATORY_INIT.SUCCESS:
      return {
        ...state,
        items: action.payload.data.data,
        totalSize: action.payload.data.meta.total,
        page: action.payload.data.meta.current_page,
        sizePerPage: action.payload.data.meta.per_page,
        filters: action.payload.filters,
      }
    case "CLEAR_ACTION_BIRTH":
      return {
        ...state,
        filters: []
      }
    default:
      return state
  }
}

export const getBirthRelatoryListData = state => {
  return {
    items: state.birth_relatory.items,
    page: state.birth_relatory.page,
    sizePerPage: state.birth_relatory.sizePerPage,
    totalSize: state.birth_relatory.totalSize,
    filters: state.birth_relatory.filters
  }
}